import { Request } from "../../Servidor/Request";

export class LitigationRequest {
    private sgeplitigio: number;
    private nome: string;

    constructor (sgeplitigio:number, nome: string){
        this.sgeplitigio = sgeplitigio;
        this.nome = nome;
    }

    /**
     * Getter sgeplitigio
     * @return {number}
     */
    public getSgeplitigio(): number {
        return this.sgeplitigio;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class LitigationStructRequest {
    private sgeplitigio: number;

    constructor (sgeplitigio:number){
        this.sgeplitigio = sgeplitigio;
    }

    /**
     * Getter sgeplitigio
     * @return {number}
     */
    public getSgeplitigio(): number {
        return this.sgeplitigio;
    }
}

export class LitigationInteractor {
    public fetchSave(request: LitigationRequest): PromiseLike<Boolean>{
        return new Promise ((res,rej) => {
            return new Request().requestPost("basico/litigio/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                      Mensagem:"Erro ao conectar!"  
                    })
                }

                let response = rs.Status == "Sucesso!"
                res(response) 
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: LitigationStructRequest): PromiseLike<LitigationRequest>{
        return new Promise ((res, rej) => {
            return new Request().requestPost("basico/litigio/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem:"Erro ao conectar!"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}
